const getters = {
  companyLogo: state => state.system.companyLogo,
  showLoader: state => state.system.showLoader,
  navigationDrawerShow: state => state.system.navigationDrawerShow,
  loaderMessage: state => state.system.loaderMessage,
  isFullPage: state => state.system.isFullPage,
  showAlert: state => state.system.showAlert,
  alertMessage: state => state.system.alertMessage,
  alertColor: state => state.system.alertColor,
  systemTopBarColor: state => state.system.systemTopBarColor,
  localRepoPath: state => state.system.localRepoPath,
  dateTimeFormat: state => state.user.dateTimeFormat,
  systemConfigPath: state => state.system.systemConfigPath,
  permission: state => state.user.permission,
  // liveServerUrl: state => state.system.liveServerUrl,
  liveServerUrl: () => 'https://manuerpapi.mybrandapp.org',
  // To show download loader
  downloadFileMessage: state => state.system.downloadFileMessage,
  showDownloadLoader: state => state.system.showDownloadLoader,
  // TO cancel download request send to server
  cancelDownloadRequestSource: state => state.system.cancelDownloadRequestSource,
  showUploadLoader: state => state.system.showUploadLoader,
  uploadFileMessage: state => state.system.uploadFileMessage,
  uploadProgressValue: state => state.system.uploadProgressValue
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js